/**
 * XML Type Detector
 */

import { SEMANTIC_TYPES } from '@/detectors/semanticTypes';
import type { ISemanticType } from '@/interfaces/ISemanticType';
import type { ITypeDetector } from '@/interfaces/ITypeDetector';

export const XmlDetector: ITypeDetector = {
  id: 'xml-detector',
  name: 'XML Detector',
  priority: 65, // Higher than JSON since XML is more specific with declaration
  detectedType: SEMANTIC_TYPES.XML,

  detect(input: string): ISemanticType | null {
    const trimmed = input.trim();
    
    // Check for XML declaration or root element
    if (!trimmed.startsWith('<?xml') && !trimmed.startsWith('<')) {
      return null;
    }

    // Simple heuristic: looks like XML if it starts with < and ends with >
    // and has matching tags
    if (!trimmed.endsWith('>')) {
      return null;
    }

    // Try to parse as XML using DOMParser
    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(trimmed, 'application/xml');
      
      // Check for parser error
      const parseError = doc.querySelector('parsererror');
      if (parseError) {
        return null;
      }

      // If it has an XML declaration, it's definitely XML
      if (trimmed.startsWith('<?xml')) {
        return SEMANTIC_TYPES.XML;
      }

      // Check if it's valid XML with a root element
      if (doc.documentElement && doc.documentElement.tagName !== 'parsererror') {
        // Avoid detecting HTML as XML
        const rootTag = doc.documentElement.tagName.toLowerCase();
        if (rootTag === 'html') {
          return null; // Let HTML detector handle it
        }
        return SEMANTIC_TYPES.XML;
      }
    } catch {
      return null;
    }

    return null;
  },
};
